import React from "react";
import {
    TableContenForLoftSummaryReport
} from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const columnNames = this.props.columnNames;
        const fullTotalRow = this.props.fullTotalRow;
        const deductionIds = this.props.deductionIds;
        const bagCount = this.props.bagCount;

        return (
            <div>
                <h3><center><u>Loft Deduction Summary Report</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route === undefined ? "All Routes" : searchData.route}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                </div>
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <table
                                style={{ overflowX: "auto", whiteSpace: "nowrap" }}>
                                <thead>
                                    <tr>
                                        <th>Route Name</th>
                                        <th>Bag Count</th>
                                        {columnNames.map((x, index) => {
                                            return (
                                                <th scope="col" key={index}>{x}</th>
                                            )
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContenForLoftSummaryReport
                                        data={reportData}
                                        contentRowNames={contentRowNames}
                                        hasEdit={false}
                                    />
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th>Total</th>
                                        <th style={{ textAlign: "right" }}>{bagCount}</th>
                                        {deductionIds.map((x, i) => {
                                            var res = fullTotalRow.find(y => y.name === x.toString());

                                            if (res) {
                                                return (
                                                    <th key={i} style={{ textAlign: "right" }}>
                                                        {res.name === "bagCount" ? res.value : res.value.toFixed(2)}
                                                    </th>
                                                );
                                            }
                                            else if (res === undefined) {
                                                return (
                                                    <th index={i} style={{ textAlign: "right" }}>{(0).toFixed(2)}</th>
                                                );
                                            }

                                        })}
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}